import AddToCollectionPopover from './AddToCollectionPopup';
import AddToCollectionPopoverContainer from './AddToCollectionPopup.container';
export default AddToCollectionPopoverContainer(AddToCollectionPopover);
